<iframe class="app-frame" [src]="baseJsUrl | safe"></iframe>
